import { request } from '@umijs/max';

// 查询图片List
export async function qryImagecfgListService() {
  return request(`/bcare/imagecfg/list`, {});
}

// 查询图片位
export async function qryThemeImgcfgService(params: any) {
  return request(`/bcare/theme/imgcfg/${params}`);
}

// 上传图片
export async function uploadImageService(imagetype: any, data: any) {
  return request(`/bcare/imagecfg/upload/${imagetype}`, {
    method: 'POST',
    data,
  });
}

// dms下载图片
export async function downloadFileService(params: any) {
  return request(`/bcare/file/dms/downloadFile`, {
    responseType: 'blob',
    params,
  });
}
